module.exports = __webpack_public_path__ + "static/media/play-icon.4f338b93.svg";